// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"3b53517f","976":"4f1e6b75"}[chunkId] + ".chunk.css";
};